import { Link } from "react-router-dom";
import { get, type RepoList as RepoPage } from "../../services/api";
import { useAsync, useTitle } from "../../hooks";
import { useAuth } from "../../hooks/AuthContext";
import { ErrorBox, Loading } from "../../components/Ui";
import { RepoList } from "../../components/RepoList";
import { CommunityAside } from "../../components/CommunityAside";
import { Icon } from "../../components/Icon";

export function Home() {
  useTitle("Home");
  const { user } = useAuth();
  const recent = useAsync(
    () => get<RepoPage>("/repositories?perPage=12&sort=updated"),
    [],
  );
  return (
    <div className="community-layout">
      <div className="community-stream">
        <div className="stream-heading">
          <h1>Home</h1>
          <Link to="/explore/guide" className="btn sm">
            <Icon name="plus" />
            Share a wiki
          </Link>
        </div>
        <section className="home-introduction">
          <h2>
            Good knowledge
            <br />
            has good company.
          </h2>
          <p>
            A place for the wikis you build, the ideas you keep,
            <br className="wide-only" /> and the people worth following.
          </p>
          <div className="row">
            <Link to="/explore">
              Explore the Library <Icon name="arrow" />
            </Link>
            {!user && <Link to="/register">Join the community</Link>}
          </div>
        </section>
        <nav className="tabs stream-tabs" aria-label="Home feed">
          <Link to="/" aria-current="page">
            Recently shared
          </Link>
          <Link
            to={
              user
                ? "/settings/following"
                : "/login?next=%2Fsettings%2Ffollowing"
            }
          >
            Following
          </Link>
          <Link to="/explore/people">People</Link>
        </nav>
        {recent.loading && !recent.data ? (
          <Loading />
        ) : recent.error ? (
          <ErrorBox error={recent.error} retry={recent.reload} />
        ) : (
          <RepoList
            repos={recent.data?.items ?? []}
            empty="The Library is ready for its first public wiki"
          />
        )}
      </div>
      <CommunityAside />
    </div>
  );
}
